import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-radio-button',
	templateUrl: './radio-button.component.html',
	styleUrls: ['./radio-button.component.scss']
})
export class RadioButtonComponent implements OnInit {
	@Input() buttons: { label: string; link: string; disabled?: boolean }[] = [];
	@Input() exact = false;
	@Input() activeBgColor = '#145E7F';
	@Input() activeBorderColor?: string;
	@Input() activeTextColor = '#fff';

	constructor() {}

	ngOnInit(): void {}
}
